export interface AppConfig {
  appId: number;
  serverSecret: string;
  baseUrl: string;
}

export interface VideoCallProps {
  appConfig: {
    appId: number;
    serverSecret: string;
    baseUrl: string;
  };
}

export type UserRole = 'USER' | 'CONSULTANT';

export interface SessionParticipant {
  role: UserRole;
  sessionLength: number;
  id: string;
  firstName: string;
  time: string;
}

export interface SessionTiming {
  sessionLength: number;
  bufferTime: number;
  startTimestamp: number;
}

export interface NotificationState {
  isOpen: boolean;
  message: string;
  severity: 'warning' | 'error';
}


export const SESSION_NOTIFICATIONS = {
  FIVE_MINUTES: {
    message: '5 minutes left to wrap up the session',
    severity: 'warning' as const,
  },
  TWO_MINUTES: {
    message: 'Session will end in 2 minutes',
    severity: 'error' as const,
  },
} as const;

export const NOTIFICATION_DURATION = 10000;
export const CONTAINER_CHECK_INTERVAL = 100;